import { forwardRef, useState } from 'react';
import { Icons } from '@/utils/Icons';
import { modalInputClass } from './Modal';

type PasswordFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: string;
};

/** Dark password input with show/hide toggle; spread `register(...)` onto it. */
const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(
  ({ error, className = '', ...props }, ref) => {
    const [show, setShow] = useState(false);

    return (
      <div>
        <div className="relative">
          <input
            ref={ref}
            type={show ? 'text' : 'password'}
            onKeyDown={(e) => e.key === ' ' && e.preventDefault()}
            className={`${modalInputClass} pr-11 ${error ? 'border-danger-red focus:border-danger-red' : ''} ${className}`}
            {...props}
          />
          <button
            type="button"
            onClick={() => setShow((value) => !value)}
            aria-label={show ? 'Hide password' : 'Show password'}
            className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-shell-muted hover:text-shell-fg"
          >
            {show ? <Icons.EyeSlash size={16} /> : <Icons.Eye size={16} />}
          </button>
        </div>
        {error && <p className="mt-1 text-xs text-danger-red">{error}</p>}
      </div>
    );
  }
);

PasswordField.displayName = 'PasswordField';

export default PasswordField;
